export class NoResult {
    static instance = new NoResult();
    constructor() { }
}
//# sourceMappingURL=no-result.js.map